/*
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2023-07-20 14:43:10
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-07-02 10:32:54
 * @FilePath: /wemeet-admin-new/src/registerServiceWorker.js
 * @Description:
 * Copyright (c) 2024 by WeMeet, All Rights Reserved.
 */
import { register } from 'register-service-worker'
import { gp } from '@vab'
const version = new Date().getTime()

function emitUnregister() {
  var event = document.createEvent('Event')
  event.initEvent('sw.unregister', true, true)
  window.dispatchEvent(event)
}

// if (process.env.NODE_ENV === 'production') {
//   register(`${process.env.BASE_URL}service-worker.js?timeStamp=${version}`, {
//     ready() {
//       console.log(
//         'App is being served from cache by a service worker.\n' +
//           'For more details, visit https://goo.gl/AFskqB'
//       )
//       if ('serviceWorker' in navigator) {
//         navigator.serviceWorker.getRegistration().then(function (registration) {
//           if (registration) {
//             registration.unregister().then(function () {
//               console.log('我进来了')
//               emitUnregister()
//             })
//           }
//         })
//       }
//     },
//     registered() {
//       console.log('Service worker has been registered.')
//     },
//     cached() {
//       console.log('Content has been cached for offline use.')
//     },
//     updatefound() {
//       console.log('New content is downloading.')
//       // gp.$baseNotify(
//       //   '检测到新版本，正在下载中，请稍后...',
//       //   '温馨提示',
//       //   'info',
//       //   'bottom-right',
//       //   8000
//       // )
//     },
//     updated() {
//       console.log('New content is available; please refresh.')
//       // gp.$baseNotify(
//       //   '更新版本完成，10S后刷新项目',
//       //   '温馨提示',
//       //   'success',
//       //   'bottom-right',
//       //   8000
//       // )
//       // setTimeout(() => {
//       //   window.location.reload()
//       // }, 10000)
//     },
//     offline() {
//       console.log(
//         'No internet connection found. App is running in offline mode.'
//       )
//     },
//     error(error) {
//       console.error('Error during service worker registration:', error)
//     },
//   })
// }
